import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { History } from './History.types';

export function useHistoryData(): Page<History>['templateFields'] {
  return useCurrentPage<Page<History>>().templateFields;
}
